import { Box, Button, Link } from "@mui/material";
import { GridRenderCellParams, GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import DataGridTamplet from "../../Helper/TableTemplet/DataGridTamplet";
import {
  emptyCases,
  getCases,
  updateCaseNumberToRow,
  updateStatusCase,
} from "../GeneralCases/CaseUtils";
import "./SubmitCases.scss";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import caseTypes from "../../../configs/caseTypeConfig";
import { setCases } from "../../../Redux/CaseSlice";
import { useTranslation } from "react-i18next";

const CaseStatusNames = {
  dismissed: "dismissed_cases",
  new: "submit_cases",
};

export function getCaseTypeFormat(params) {
  if (caseTypes.hasOwnProperty(params.row.case_type)) {
    return caseTypes[params.row.case_type].title;
  } else {
    return params.row.case_type;
  }
}

const screenType = 'submit';

const SubmitCase = () => {
  const { t } = useTranslation("submitCases");
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const case_type = searchParams.get("type");
  const [queryParams, setQueryParams] = useState({});

  const defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );

  const columns = [
    // {
    //   field: "id",
    //   headerName: "id",
    //   width: 200,
    // },
    // {
    //   field: "time_before_expire",
    //   headerName: "Time Befor Expire",
    //   width: 200,
    // },
    {
      field: "case_type", sortable: false,
      headerName: t("type"), width: 170,
      valueGetter: getCaseTypeFormat
    },
    {
      field: "est_value",
      headerName: t("est_value"),
      width: 120,
      type: "number",
      valueFormatter: ({ value }) => value && value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    {
      field: "country",
      headerName: t("country"),
      width: 120
    },
    {
      field: "case_number",
      headerName: t("case_number"),
      editable: case_type === "new",
      width: 180,
    }
  ];

  const extendColumnsSubmit = [
    ...columns,
    {
      field: "actions",
      headerName: t("actions"),
      width: 200,
      renderCell: (params: GridRenderCellParams) => (
        <strong>
          <Link
            href={params.row.link}
            target="_blank"
            underline="hover"
            className="yello-color"
          >
            {t("open")}
          </Link>
          <ContentCopyOutlinedIcon
            className="pointer"
            sx={{ marginLeft: "20px" }}
            onClick={() => copyTextLink(params.row.data, params.row.case_type)}
          ></ContentCopyOutlinedIcon>
          <Button
            variant="outlined"
            size="small"
            className="submit-btn"
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => updateCaseNumber(params.id, params.row.case_number)}
          >
            {t("submit")}
          </Button>
        </strong>
      ),
    },
    {
      field: "dismiss",
      headerName: t("dismiss"),
      width: 150,
      renderCell: (params: GridRenderCellParams) => (
        <strong>
          <Button
            variant="text"
            size="small"
            className="red-color"
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => dismissCase(params.id)}
          >
            {t("dismiss")}
          </Button>
        </strong>
      ),
    },
  ];

  const extendColumnsDismiss = [
    ...columns,
    {
      field: "activate",
      headerName: t("activate"),
      width: 150,
      renderCell: (params: GridRenderCellParams) => (
        <strong>
          <Button
            variant="text"
            size="small"
            className="green-color"
            tabIndex={params.hasFocus ? 0 : -1}
            onClick={() => activateCase(params.id)}
          >
            {t("activate")}
          </Button>
        </strong>
      ),
    },
  ];


  //const textFieldLabel = "Search by orderId or by product FNSKU";

  let casesTypeList = useSelector((state: any) => state.general.case_types);

  const cases = useSelector((state: any) => state.case.cases_list);
  const lastCaseDate = useSelector((state: any) => state.case.last_case_date);

  const category = searchParams.get("category");

  let filters = [
    {
      id: "urgency",
      name: t("urgency"),
      values: [
        { value: 2, label: t("2_month") },
        { value: 10, label: t("10_month") },
        { value: 18, label: t("18_month") },
      ],
    },
    {
      id: "categoryType",
      name: t("category_type"),
      values: casesTypeList.map((caseType) => {
        const caseTypeConfig = caseTypes[caseType.name];
        if (!caseTypeConfig) {
          console.warn(`Missing configuration for case type: ${caseType.name}`);
          return { value: caseType.name, label: t("unknown") };
        }
        return { value: caseType.name, label: caseTypeConfig.title };
      }),
    },
  ];

  const [filterValues, setFilterValues] = useState({
    urgency: "",
    categoryType: category,
    fieldText: ""
  });

  // Dynamically set the textFieldLabel based on the selected categoryType
  //filterValues.categoryType.print()
  //const textFieldLabel = filterValues['categoryType'] === "Missing Inbound" ? "Search by orderId or by product SKU" : "Search by orderId or by product FNSKU";

  const [textFieldLabel, setTextFieldLabel] = useState(t("search_by_fnsku"));

  useEffect(() => {

    setTextFieldLabel(
      filterValues.categoryType === "Lost Inbound"
        ? t("search_by_sku")
        : t("search_by_fnsku")
    );
  }, [filterValues.categoryType, t]);

  const search = (list, inputValue) => {
    const isMissingInbound = filterValues['categoryType'] === "Lost Inbound";
    if (defaultAccount && defaultAccount.id) {
      const params = {
        account_id: defaultAccount.id,
        status_case_type: case_type,
        fieldText: inputValue,
        urgency: filterValues['urgency'],
        categoryType: filterValues['categoryType'],
        filterBy: isMissingInbound ? "SKU" : "FNSKU" // Add this parameter to specify the filtering type
      };
      setQueryParams(params)
      getCases(dispatch, params, screenType);
    }
    // var filteredCases;
    // filteredCases =
    //   filterValues["categoryType"] != ""
    //     ? list.filter(
    //       (item) => item.case_type === filterValues["categoryType"]
    //     )
    //     : list;
    // filteredCases =
    //   filterValues["urgency"] != ""
    //     ? filteredCases.filter(
    //       (item) => item.months_before_expire <= filterValues["urgency"]
    //     )
    //     : filteredCases;
    // return autotomaticSearch(filteredCases, inputValue);
  };

  // const autotomaticSearch = (list, inputValue) => {
  //   var filteredCases =
  //     inputValue != ""
  //       ? list.filter(
  //         (item) =>
  //           item.fnsku_list.filter((fnsku) => fnsku.startsWith(inputValue))
  //             .length > 0 ||
  //           item.orders_id_list.filter((order_id) =>
  //             order_id.startsWith(inputValue)
  //           ).length > 0
  //       )
  //       : list;
  //   return filteredCases;
  // };

  useEffect(() => {
    if (defaultAccount && defaultAccount.id) {
      const params = {
        account_id: defaultAccount.id,
        status_case_type: case_type,
      };
      if (category) {
        params["categoryType"] = category;
      };
      setQueryParams(params);
      getCases(dispatch, params, screenType);
    }
  }, [defaultAccount, case_type]);

  useEffect(() => () => emptyCases(dispatch), [case_type]);

  const dismissCase = (case_id) => {
    updateStatusCase(dispatch, case_id, 'dismissed', queryParams, screenType);
  };

  const activateCase = (case_id) => {
    updateStatusCase(dispatch, case_id, 'new', queryParams, screenType);
  };

  const updateCaseNumber = (id, caseNumber) => {
    if (!caseNumber) {
      alert('Please enter Case Number and click "Enter" or "Tab"');
    } else {
      updateCaseNumberToRow(
        dispatch,
        defaultAccount.id,
        id,
        caseNumber,
        queryParams,
        screenType
      );
    }
  };

  const copyTextLink = (data, caseType) => {
    let copyText = '';
    if (caseTypes.hasOwnProperty(caseType) && caseTypes[caseType].text !== null) {
      copyText = caseTypes[caseType].text + data + "\nThanks";
    } else {
      copyText = 'not found';
    }
    return navigator.clipboard.writeText(copyText);
  }

  return (
    <div>
      <h2>{t(CaseStatusNames[case_type])}</h2>
      {case_type === "new" && (
        <Box >
          <p className="text-submit">
            {t("submit_instruction")}
          </p>
          {lastCaseDate && <p className="text-submit align-right">{t("last_case_date")}: {lastCaseDate}</p>}
        </Box>
      )}
      <DataGridTamplet
        columns={case_type === "new" ? extendColumnsSubmit : extendColumnsDismiss}
        rows={cases}
        filters={filters}
        textFieldLabel={textFieldLabel}
        selectedFiltersValues={filterValues}
        onSearch={search}
        setSelectedFiltersValues={setFilterValues}
        filterInClientSide={false}
      />
    </div>
  );
};
export default SubmitCase;
